import { useEffect, useState } from "react";
import "./styles/aviator.css";
import startAviatorGame from "./hooks/aviatorEngine";

export default function AviatorPage() {
  const [sound, setSound] = useState(true);
  const [music, setMusic] = useState(true);
  const [animation, setAnimation] = useState(true);

  useEffect(() => {
    startAviatorGame();
  }, []);

  return (
    <>
      <>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <title>Aviator Game</title>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
        />
        <link rel="stylesheet" href="/aviator/style.css" />
        <link
          rel="shortcut icon"
          href="/aviator/favicon.png"
          type="image/x-icon"
        />
        <div className="aviator_page">
          <div id="alertBox">
            <span id="alertMessage" />
          </div>
          {/* my bet history */}
          <div className="modal-overlay">
            <div className="bet-modal">
              <div className="modal-header">
                <h6>MY BET HISTORY</h6>
                <span className="close">✕</span>
              </div>
              <div className="table-head">
                <span>Date</span>
                <span>Bet INR</span>
                <span>X</span>
                <span>Cash out INR</span>
              </div>
              <div id="myBetList" />
              <button className="load-more">Load more</button>
            </div>
          </div>
          {/* FREE BETS MODAL */}
          <div className="modal-overlay" id="freeBetOverlay">
            <div className="bet-modal">
              {/* Header */}
              <div className="modal-header">
                <h6>FREE BETS MANAGEMENT</h6>
                <span className="close" id="closeFreeBet">
                  ✕
                </span>
              </div>
              {/* Play with cash option */}
              <div className="cash-option">
                <span className="radio" />
                <span>Play with cash</span>
              </div>
              {/* Active free bets */}
              <div className="free-bet-header">
                <span>ACTIVE FREE BETS</span>
                <button className="archive-btn">
                  <i className="fa-solid fa-clock-rotate-left" />
                  <span> Archive</span>
                </button>
              </div>
              {/* Empty state */}
              <div className="empty-state">
                <div className="ticket-icon">
                  <img src="/aviator/ticket.svg" alt="ticket-icon" />
                </div>
                <p>No Active Free Bets. Yet!</p>
              </div>
            </div>
          </div>
          {/* GAME LIMITS MODAL */}
          <div className="modal-overlay" id="gameLimitOverlay">
            <div className="bet-modal">
              {/* Header */}
              <div className="modal-header">
                <h6>GAME LIMITS</h6>
                <span className="close" id="closeGameLimit">
                  ✕
                </span>
              </div>
              {/* Limits box */}
              <div className="limits-box">
                <div className="limit-row">
                  <span>Minimum bet INR:</span>
                  <span className="limit-value">10.00</span>
                </div>
                <div className="limit-row">
                  <span>Maximum bet INR:</span>
                  <span className="limit-value">10,000.00</span>
                </div>
                <div className="limit-row">
                  <span>Maximum win for one bet INR:</span>
                  <span className="limit-value">1,000,000.00</span>
                </div>
              </div>
            </div>
          </div>
          {/* HOW TO PLAY MODAL */}
          <div className="modal-overlay" id="howToPlayOverlay">
            <div className="howtoplay-modal">
              {/* Header */}
              <div className="modal-header">
                <h6>HOW TO PLAY?</h6>
                <span className="close" id="closeGameLimit">
                  ✕
                </span>
              </div>
              {/* Video / Header area */}
              <div className="video-placeholder">
                <div className="warning">
                  <span className="warn-icon">!</span>
                  <div>
                    <p>
                      This video is age restricted and only available on
                      YouTube.
                    </p>
                    <a href="#" target="_blank">
                      Watch on YouTube
                    </a>
                  </div>
                </div>
                <button className="play-btn">▶</button>
              </div>
              {/* Steps */}
              <div className="steps">
                <div className="step">
                  <span className="step-no">01</span>
                  <span className="step-text">
                    Make a bet, or even two at same time and wait for the round
                    to start.
                  </span>
                </div>
                <div className="step">
                  <span className="step-no">02</span>
                  <span className="step-text">
                    Look after the lucky plane. Your win is bet multiplied by a
                    coefficient of lucky plane.
                  </span>
                </div>
                <div className="step">
                  <span className="step-no">03</span>
                  <span className="step-text">
                    Cash Out before plane flies away and money is yours!
                  </span>
                </div>
              </div>
              {/* Footer */}
              <div className="rules-footer" id="openRules">
                detailed rules
              </div>
            </div>
          </div>
          {/* GAME RULES MODAL */}
          <div className="modal-overlay" id="gameRulesOverlay">
            <div className="rules-modal">
              {/* Header */}
              <div className="rules-header">
                <span>GAME RULES</span>
                <button className="close" id="closeGameRules">
                  ✕
                </button>
              </div>
              {/* Body */}
              <div className="rules-body">
                <p className="text-grey">
                  Aviator is a new generation of iGaming entertainment. You can
                  win many times more, in seconds! Aviator is built on a
                  provably fair system.
                </p>
                <a href="#" className="link">
                  Read more about provably fair system
                </a>
                <h6 className="section-title">HOW TO PLAY</h6>
                {/* YouTube */}
                <div className="video-wrapper">
                  <iframe
                    src="https://www.youtube.com/embed/PZejs3XDCSY"
                    allowFullScreen=""
                  />
                </div>
                {/* Steps */}
                <h6 className="steps-title">
                  Aviator is as easy to play as 1-2-3:
                </h6>
                <div className="steps">
                  <div className="step">
                    <span className="step-no">01</span>
                    <p>
                      <b>Bet</b> before take-off
                    </p>
                  </div>
                  <div className="step">
                    <span className="step-no">02</span>
                    <p>
                      <b>Watch</b> as your Lucky Plane takes off and winnings
                      increase
                    </p>
                  </div>
                  <div className="step">
                    <span className="step-no">03</span>
                    <p>
                      <b>Cash out</b> before the plane disappears
                    </p>
                  </div>
                </div>
                <p className="text-grey">
                  If you did not cash out before the plane flies away, your bet
                  is lost.
                </p>
                {/* Rules List */}
                <div className="rules-section">
                  <h6>MORE DETAILS</h6>
                  <ul>
                    <li>
                      The win multiplier starts at 1x and increases
                      continuously.
                    </li>
                    <li>Your winnings equal bet × cash-out multiplier.</li>
                    <li>
                      Multiplier is generated using a provably fair algorithm.
                    </li>
                  </ul>
                </div>
                <div className="rules-section">
                  <h6>BET &amp; CASH OUT</h6>
                  <ul>
                    <li>Select amount and press Bet.</li>
                    <li>Press Cash Out to secure winnings.</li>
                    <li>You can place two bets simultaneously.</li>
                  </ul>
                </div>
                <div className="rules-section">
                  <h6>AUTO PLAY</h6>
                  <ul>
                    <li>Enable Auto Bet from Auto tab.</li>
                    <li>Auto Cash Out triggers at chosen multiplier.</li>
                  </ul>
                </div>
                <div className="rules-section">
                  <h6>OTHER</h6>
                  <ul>
                    <li>Connection loss triggers auto cash out.</li>
                    <li>Malfunction voids affected bets.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* PROVABLY FAIR MODAL */}
          <div className="modal-overlay" id="provablyFairOverlay">
            <div className="bet-modal provably-modal">
              {/* Header */}
              <div className="modal-header">
                <h6>PROVABLY FAIR SETTINGS</h6>
                <span className="close" id="closeProvably">
                  ✕
                </span>
              </div>
              {/* Description */}
              <p className="pf-desc">
                This game uses Provably Fair technology to determine game
                result. This tool gives you ability to change your seed and
                check fairness of the game.
                <span className="pf-link">❓ What is Provably Fair</span>
              </p>
              <hr className="divider" />
              {/* Client seed */}
              <div className="section">
                <div className="section-title">
                  <img src="/aviator/client.svg" alt="client-icon" />
                  <span>Client (your) seed:</span>
                </div>
                <p className="section-note">
                  Round result is determined from combination of server seed and
                  first 3 bets of the round.
                </p>
                {/* Option 1 */}
                <div className="radio-row active">
                  <div>
                    <input
                      type="radio"
                      name="clientSeed"
                      defaultChecked=""
                      className="radio-dot"
                    />
                    <span>Random on every new game</span>
                  </div>
                  <div className="seed-box">
                    <span>Current: xm23zD4AxXQr4MKFrzU5</span>
                    <span className="copy">
                      <i className="fa-regular fa-copy" />
                    </span>
                  </div>
                </div>
                <div className="radio-row">
                  <input type="radio" name="clientSeed" className="radio-dot" />
                  <span>Enter manually</span>
                  <div className="seed-box disabled">
                    <span>Current: 2tIpsXn9iKosvVzOK65t-0</span>
                    <span className="copy">
                      <i className="fa-regular fa-copy" />
                    </span>
                  </div>
                  <button className="change-btn">CHANGE</button>
                </div>
              </div>
              <hr className="divider" />
              {/* Server seed */}
              <div className="section">
                <div className="section-title">
                  <span>
                    <img src="/aviator/server.svg" alt="server-icon" />
                    <span> Server seed SHA256:</span>
                  </span>
                </div>
                <div className="seed-box full">
                  <span>
                    ea719798bec2a9d5e08c008a989ccfb382064e98b9174cf80c6850e2fbc34203
                  </span>
                </div>
              </div>
              <p className="footer-note">
                You can check fairness of each bet from bets history
              </p>
            </div>
          </div>
          <div className="modal-overlay" id="avatarModal">
            <div className="avatar-modal">
              {/* Header */}
              <div className="modal-header">
                <h6>CHANGE AVATAR</h6>
                <span className="close" id="closeAvatarBet">
                  ×
                </span>
              </div>
              {/* Dynamic avatar grid */}
              <div id="avatarGrid" className="avatar-grid" />
              <span className="close close-btn" id="closeAvatarBet">
                Close
              </span>
            </div>
          </div>
          {/* Slide-in Sidebar (from right) */}
          <div className="sidebar" id="sidebar">
            <div className="header">
              <div className="username">
                <div className="avatar" id="user_avatar_dynamic">
                  <img
                    id="currentAvatar"
                    src="/aviator/avatar/av-1.png"
                    className="avatar"
                  />
                </div>
                <div className="username" id="user_id">
                  demo_97946
                </div>
              </div>
              <button className="change-avatar-btn" id="openAvatarModal">
                Change Avatar
              </button>
            </div>
            <div className="menu-item">
              <span className="icon">🔊</span>
              <span>Sound</span>
              <div
                className={sound ? "toggle active" : "toggle"}
                id="btnBackgroundAudio"
                onClick={() => setSound(!sound)}
              />
            </div>

            <div className="menu-item">
              <span className="icon">🎵</span>
              <span>Music</span>
              <div
                className={music ? "toggle active" : "toggle"}
                id="btnPlaneStartAudio"
                onClick={() => setMusic(!music)}
              />
            </div>

            <div className="menu-item">
              <span className="icon">⚡</span>
              <span>Animation</span>
              <div
                className={animation ? "toggle active" : "toggle"}
                id="btnPlaneCrashAudio"
                onClick={() => setAnimation(!animation)}
              />
            </div>
            {/* <div class="section-title">Free Demo Bets</div> */}
            <div className="menu-item" id="freeBetBtn">
              <span className="icon star">★</span>
              <span>Free Bets</span>
            </div>
            <div className="menu-item" id="myBetListBtn">
              <span className="icon">📜</span>
              <span>My Bet History</span>
            </div>
            <div className="menu-item" id="gameLimitBtn">
              <span className="icon">🎮</span>
              <span>Game Limits</span>
            </div>
            <div className="menu-item" id="howToPlayBtn">
              <span className="icon">❓</span>
              <span>How To Play</span>
            </div>
            <div className="menu-item" id="gameRulesBtn">
              <span className="icon">📖</span>
              <span>Game Rules</span>
            </div>
            <div className="menu-item" id="provablyFairOverlayBtn">
              <span className="icon">🛡️</span>
              <span>Provably Fair Settings</span>
            </div>
            <div className="footer">
              <div className="footer-content">
                <a href="#" className="footer-link">
                  <i className="fa fa-home" />
                  <span>HOME</span>
                </a>
              </div>
            </div>
          </div>
          <header className="header-area">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-lg-12 col-md-12" style={{ margin: "0" }}>
                  <div className="inner_header_part d-flex justify-content-between align-items-center">
                    <div className="header_left">
                      <div className="header_logo">
                        <a href="#">
                          <img
                            src="/aviator/aviator-logo.svg"
                            alt="Aviator logo"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="header_right d-flex align-items-center">
                      <div className="balance-top mr-1 text-success font-weight-bold">
                        <span id="user_balance">0.00</span> INR
                      </div>
                      <div className="header_bnt">
                        <button className="hamburger" id="openProfileSidebar">
                          <img
                            src="/aviator/burger.svg"
                            style={{ width: 25 }}
                          />
                        </button>

                        <button className="hamburger">
                          <img
                            src="/aviator/message.svg"
                            style={{ width: 20 }}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <section className="game-interface">
            <aside className="betting-sidebar">
              <div className="sidebar-tabs">
                <button className="tab active" id="allBetsBtn">
                  All Bets
                </button>
                <button className="tab" id="previousBtn">
                  Previous
                </button>
                <button className="tab" id="topWinnerBtn">
                  Top
                </button>
              </div>
              <div className="bet-stats-container">
                <div className="bet-stats">
                  <div className="" id="betStatsAvtars">
                    <div className="avatars" />
                    <span id="leftBetParticipant">0</span>
                    <span>/</span>
                    <span id="totalBetParticipant">0</span>
                    <span>Bets</span>
                  </div>
                  <div className="total-win-box">
                    <span className="total-win-value">0.00</span>
                    <span className="total-win-label">Total win INR</span>
                  </div>
                </div>
                <div className="bet-stats-loading-bar-container">
                  <div className="bet-stats-loading-bar" />
                </div>
              </div>
              <div className="round-header" style={{ display: "none" }}>
                <span className="bet-col">Date &amp; Time</span>
                <span className="bet-col bet-end" />
                <span className="bet-col">X</span>
                <span className="bet-col bet-end" />
              </div>
              <div className="bet-header">
                <span className="bet-col bet-player">Player</span>
                <span className="bet-col">Bet INR</span>
                <span className="bet-col">X</span>
                <span className="bet-col bet-end">Win INR</span>
              </div>
              <div className="live-bets-list" id="betList" />
              <div className="top-bets-list" id="topBetList" />
              <div className="game-footer">
                <span className="game-footer__item">
                  <img
                    src="/aviator/pf-icon.svg"
                    alt="shield"
                    className="game-footer__icon"
                  />
                  <span>Provably Fair Game</span>
                </span>
                <span className="game-footer__item">
                  <span>Powered by</span>
                  <img
                    src="/aviator/logo-name.svg"
                    alt="spribe"
                    className="game-footer__logo"
                  />
                </span>
              </div>
            </aside>
            <main className="game-main">
              <div className="history-wrapper" id="historyWrapper">
                <div className="history-bar" id="historyBar" />
                <button className="history-more" id="historyMore">
                  <span className="icon">
                    <i className="fa-solid fa-ellipsis" />
                  </span>
                </button>
                <div className="history-overlay-header">
                  <span className="title">Round History</span>
                  <button className="history-close" id="historyClose">
                    <span className="icon">
                      <i className="fa-solid fa-xmark" />
                    </span>
                  </button>
                </div>
              </div>
              <div className="game-canvas">
                {/* <div class="fun-mode-tag">FUN MODE</div> */}
                <svg
                  id="animatedPlane"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 160 80"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <defs>
                    <g id="Symbol_5_0_Layer0_0_FILL">
                      <path
                        fill="#E50539"
                        d=" M 133.55 31.85 L 133.05 31.75 132.85 31.9 Q 132.25 32.15 132.35 32.65 133.2 37.4 134.35 41.9 134.5 42.55 135.4 42.45 L 135.65 42.35 Q 139.7 40.05 142.6 35.95 143.55 34.7 142.2 34.05 139.2 32.65 133.55 31.85 M 133.9 33.95 Q 133.85 33.8 133.85 33.65 133.95 33.4 134.25 33.3 L 134.4 33.25 136.95 33.7 Q 139.6 34.3 140.45 34.7 141.2 35.05 141.1 35.35 L 134.6 37 133.9 33.95 M 135.65 44.8 L 134.85 44.8 135.45 56.05 Q 135.55 57.45 136.3 59.3 136.6 60.35 137.5 62.45 L 141.95 73.4 Q 142.1 73.9 142.5 73.95 143 74.05 143.35 73.7 144.8 72.4 144.7 70.95 144.1 59.4 143.05 54.45 L 139.1 42.3 Q 137.6 43.75 136.15 44.6 L 135.65 44.8 M 142.45 71.3 L 142.4 71 Q 138.55 62.25 137.05 57.55 136.75 56.65 137.15 56.15 L 137.85 55.75 143.3 68 Q 144.1 70.3 142.6 71.05 L 142.45 71.3 M 129.35 0.45 Q 129.2 0.1 128.8 0.05 128.4 -0.1 128.1 0.2 126.55 1.85 126.65 3.65 127.1 14.2 128.25 19.65 L 132 30.05 132.7 29.75 133.2 29.7 Q 134.7 29.85 136.75 30.45 L 135.9 18.85 Q 135.7 16.1 133.8 11.7 L 129.35 0.45 M 128.95 2.05 L 129.05 2.2 Q 132.2 10.1 133.85 15.2 134.5 16.75 133.3 17.15 L 133.15 17.25 133.1 17 Q 128.5 7.95 127.8 5.45 127.25 3.55 128.8 2.15 L 128.95 2.05 Z"
                      />
                    </g>
                    <g id="Symbol_5_0_Layer0_1_FILL">
                      <path
                        fill="#E50539"
                        d=" M 90.75 -2.25 Q 88.5 -2.05 86.45 -1.5 L 85.15 2.9 Q 83.1 1.2 80.95 -0.25 L 76.8 0.6 77.2 1.85 Q 79.25 3.1 83 5.75 82.35 7.7 81.1 10.5 L 83.5 10.1 Q 83.4 11.15 82.85 11.6 82.45 11.85 81.35 12.15 L 79.15 12.6 Q 78.45 12.75 78.2 13.8 78.1 14.45 78.15 14.95 L 86.15 12.9 86.5 7.45 Q 87.75 8.6 90.05 11.65 L 93.65 10.5 Q 93.2 10.1 88.3 5 90.4 -1.3 90.75 -2.25 M 58.6 -10.05 Q 53.4 -7.25 49.5 -5.45 47.9 -4.8 47.1 -3.75 46.75 -3.4 46.05 -2.15 45.8 -1.65 46.25 -1.55 L 60.5 3.55 Q 60.3 3.25 60.35 3.05 60.35 2.9 60.65 2.8 73.15 -1.2 81.45 -2.8 88.45 -4.05 91.85 -4.4 94.25 -4.55 96.75 -4.3 L 99 -3.9 Q 99.9 -3.55 99.95 -2.7 100.45 0.5 101.65 5.15 102.9 10.05 103.9 12.3 103.45 12.95 102.75 12.85 102.3 12.85 100.8 10.85 100.55 10.75 100.25 10.75 76.85 18.7 42.15 24.8 3.2 31.6 -11.55 28.2 L -11.55 28.3 -17.35 30.95 Q -16.5 31.85 -14.25 34.1 -11.2 35.6 -5.3 33.55 L -4.45 35.55 Q -4.15 36.65 -3.35 36.8 -2.65 36.95 0.4 36.5 11.55 35 38.6 30.75 68.05 26.15 76.9 24.35 94.15 20.95 100.95 18.35 106 16.4 107.1 14.5 108.4 12.25 107.15 6.9 105 -2.9 104.7 -4.05 103.85 -6.2 102.1 -7 100.85 -7.6 98.7 -7.65 95 -7.65 91.4 -7.35 85.9 -6.75 80.5 -6.25 75.8 -5.75 71.9 -8 68 -10.3 67.35 -10.65 65.4 -11.6 64.1 -11.7 62.2 -11.9 58.6 -10.05 M 61.1 -2.05 Q 60.85 -3.15 62.5 -3.55 62.8 -3.6 66.1 -4.65 66.7 -4.85 66.7 -5.4 66.8 -5.95 66.35 -6.2 L 61.9 -9.1 Q 64.1 -10.3 66.5 -9.05 69.7 -7.4 72.3 -5.6 72.85 -5.2 72.75 -4.75 72.65 -4.25 72.2 -4.15 L 61.75 -1.15 Q 61.25 -1.6 61.1 -2.05 M 21.3 -6.85 Q 14.9 -8.85 8.95 -4.6 L 8.95 -4.55 13.45 1.95 Q 13.65 2.25 13.9 2.15 L 20.85 0 21.05 0.9 Q 21.1 1.8 20.75 2.5 20.45 3.1 19.75 3.45 L 15.2 4.95 16.65 7.35 21.9 5.6 Q 22.35 7.85 21.4 8.3 L 18.1 9.7 21.45 15.2 19.4 15.8 Q 10 18.7 8.55 18.45 5.7 17.95 -0.05 12.05 -5.8 5.6 -7.3 4.5 -9.65 2.7 -13.45 3.25 -16.5 3.7 -21.9 6 -23.5 6.65 -23.65 9.5 L -17.35 7.7 Q -17.1 9.6 -18.05 9.9 -21.25 11.05 -23.7 11.75 -24.6 12.25 -24.5 14.8 L -21.6 14.15 Q -21.35 14.05 -21.2 14.25 L -11.25 26.7 Q -10.5 26.65 -7.95 26.1 L -15.05 15.35 Q -15.15 15.15 -15.1 14.95 -14.95 14.75 -14.8 14.65 -12.85 14.1 -11.95 14.05 -9.65 13.9 -8 15.5 -6.3 17.15 -3.9 18.6 -0.25 20.7 2.95 21 4.55 21.2 4.45 21.75 L 2.25 22.45 Q 1.45 22.65 1.4 23.8 1.45 24.35 1.6 24.85 L 25.6 19.9 Q 25.8 19.75 26 19.95 L 28.35 22.75 Q 28.75 23.4 29.5 23.3 33.85 22.95 51.95 19.1 70 15.1 71.35 14.3 72 13.85 72.3 12.3 72.4 11.35 71.15 10.9 31.45 -3.85 21.3 -6.85 Z"
                      />
                    </g>
                  </defs>
                  <g id="planeGroup">
                    <g transform="matrix(1,0,0,1,24.5,34.75)">
                      <use xlinkHref="#Symbol_5_0_Layer0_1_FILL" />
                    </g>
                    <g id="propellerGroup">
                      <use xlinkHref="#Symbol_5_0_Layer0_0_FILL" />
                    </g>
                  </g>
                </svg>
                <div id="multiplier">
                  <span className="flew-away">FLEW AWAY</span>
                  <span className="multSpan" />
                </div>
                <div id="timer-modal">
                  <img
                    src="/aviator/UFC-Officia-Partner-Aviator.png"
                    className="responsive-img large"
                    alt="UFC Official Partner Aviator"
                  />
                  <div id="loading-bar-container">
                    <div id="loading-bar" />
                  </div>
                  <img
                    src="/aviator/spribe-established.png"
                    className="responsive-img small"
                    alt="Spribe Established"
                  />
                </div>
                <div className="users-count" id="usersCount">
                  <div className="drop-avatars avatars" />
                  <span className="count-text" />
                </div>
                <canvas id="gameCanvas" />
              </div>
              <div className="betting-controls">
                {/* BET BOX 1 */}
                <div className="bet-box">
                  <div className="bet-tabs" id="betTabs1">
                    <button className="bet-tab active" data-tab="bet">
                      Bet
                    </button>
                    <button className="bet-tab" data-tab="auto">
                      Auto
                    </button>
                  </div>
                  {/* Bet Panel */}
                  <div className="bet-box-inner" id="betPanel1">
                    <div className="input-controls">
                      <div className="number-picker">
                        <button id="minusBtn1">-</button>
                        <input
                          type="number"
                          id="betAmount1"
                          defaultValue={10.0}
                          step="0.01"
                          min={0}
                          className="bet-amount-input"
                        />
                        <button id="plusBtn1">+</button>
                      </div>
                      <div className="quick-amounts">
                        <button className="q-amt" data-value={10}>
                          10
                        </button>
                        <button className="q-amt" data-value={50}>
                          50
                        </button>
                        <button className="q-amt" data-value={100}>
                          100
                        </button>
                        <button className="q-amt" data-value={1000}>
                          1000
                        </button>
                      </div>
                    </div>
                    <button className="bet-btn" id="actionBtn1" data-side={1}>
                      BET <span id="betAmountSpan1">2.00 INR</span>
                    </button>
                  </div>
                  {/* Auto Panel */}
                  <div className="auto-panel" id="autoPanel1">
                    <div className="auto-row">
                      <span className="auto-label">Auto Bet</span>
                      <div className="toggle" id="btnAutoBet1" />
                    </div>
                    <div className="auto-cashout-control">
                      <div className="auto-row">
                        <span className="auto-label">Auto Cash Out</span>
                        <div className="toggle" id="btnAutoCashout1" />
                      </div>
                      <div className="auto-row auto-input-row">
                        <div className="input-wrap">
                          <input
                            type="number"
                            step="0.01"
                            defaultValue={2.0}
                            placeholder={2.0}
                            className="auto-input"
                            id="autoInputMultiplier1"
                          />
                          <i
                            className="x-suffix fa fa-times"
                            id="clearAutoInput1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* BET BOX 2 */}
                <div className="bet-box">
                  <div className="bet-tabs" id="betTabs2">
                    <button className="bet-tab active" data-tab="bet">
                      Bet
                    </button>
                    <button className="bet-tab" data-tab="auto">
                      Auto
                    </button>
                  </div>
                  {/* Bet Panel */}
                  <div className="bet-box-inner" id="betPanel2">
                    <div className="input-controls">
                      <div className="number-picker">
                        <button id="minusBtn2">-</button>
                        <input
                          type="number"
                          id="betAmount2"
                          defaultValue={10.0}
                          step="0.01"
                          min={0}
                          className="bet-amount-input"
                        />
                        <button id="plusBtn2">+</button>
                      </div>
                      <div className="quick-amounts">
                        <button className="q-amt" data-value={10}>
                          10
                        </button>
                        <button className="q-amt" data-value={50}>
                          50
                        </button>
                        <button className="q-amt" data-value={100}>
                          100
                        </button>
                        <button className="q-amt" data-value={1000}>
                          1000
                        </button>
                      </div>
                    </div>
                    <button className="bet-btn" id="actionBtn2" data-side={2}>
                      BET <span id="betAmountSpan2">2.00 INR</span>
                    </button>
                  </div>
                  {/* Auto Panel */}
                  <div className="auto-panel" id="autoPanel2">
                    <div className="auto-row">
                      <span className="auto-label">Auto Bet</span>
                      <div className="toggle" id="btnAutoBet2" />
                    </div>
                    <div className="auto-cashout-control">
                      <div className="auto-row">
                        <span className="auto-label">Auto Cash Out</span>
                        <div className="toggle" id="btnAutoCashout2" />
                      </div>
                      <div className="auto-row auto-input-row">
                        <div className="input-wrap">
                          <input
                            type="number"
                            step="0.01"
                            defaultValue={2.0}
                            placeholder={2.0}
                            className="auto-input"
                            id="autoInputMultiplier2"
                          />
                          <i
                            className="x-suffix fa fa-times"
                            id="clearAutoInput2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </section>
          <audio loop hidden id="backgroundAudio">
            <source src="/aviator/audio/background.mp3" type="audio/mpeg" />
          </audio>
          <audio hidden="" id="planeStartAudio">
            <source src="/aviator/audio/game-start.mp3" type="audio/mpeg" />
          </audio>
          <audio hidden="" id="planeCrashAudio">
            <source src="/aviator/audio/plane-crash.mp3" type="audio/mpeg" />
          </audio>
        </div>
      </>
    </>
  );
}
